export default [
  { value: "Treppenhausreinigung", label: "Treppenhausreinigung" },
  {
    value: "Treppenhausfensterreinigung",
    label: "Treppenhausfensterreinigung"
  },
  { value: "Dachboden reinigen", label: "Dachboden reinigen" },
  { value: "Kellergang reinigen", label: "Kellergang reinigen" },
  { value: "Briefkastenanlage reinigen", label: "Briefkastenanlage reinigen" },
  { value: "Grünflächenpflege", label: "Grünflächenpflege" },
  { value: "Winterdienst", label: "Winterdienst" },
  { value: "Anliegerpflichten", label: "Anliegerpflichten" },
  {
    value: "Müllbehälter stellen / verräumen",
    label: "Müllbehälter stellen / verräumen"
  }
];
